import { mapState } from 'vuex';
import { getProductionLine, getOutsourcer } from '@/api/personnelWorkHour';
export const common = {
  mounted() {
    this.formInfo && this.getProLineAndOut(this.formData, 'formInfo');
  },
  computed: {
    ...mapState({
      productionLine: state => state.personnelWorkHour.productionLine,
      outsourcer: state => state.personnelWorkHour.productionLine,
    }),
  },
  methods: {
    // 获取产线数据
    // eslint-disable-next-line camelcase
    getProLineAndOut({ start_time, end_time }, formInfo) {
      this.getProLine({ start_time, end_time }, formInfo);
      this.getOutsourcer({ start_time, end_time }, formInfo);
    },
    // eslint-disable-next-line camelcase
    async getProLine({ start_time, end_time }, formInfo) {
      const startTimeNum = start_time.getTime();
      const endTimeNum = end_time.getTime();
      if (this.productionLine.length === 0 || startTimeNum !== this.formData.start_time
        || endTimeNum !== this.formatDate.end_time) {
        // eslint-disable-next-line no-underscore-dangle
        let _data = await getProductionLine({
          start_time: startTimeNum,
          end_time: endTimeNum,
        });
        _data = _data.map(item => ({
          value: item.id,
          key: item.label,
        }));
        this[formInfo].listTypeInfo.proline = [{ value: 0, key: '全部' }].concat(_data);
        this.$store.commit('SET_RPODUCTIONLINE', _data);
      } else {
        this[formInfo].listTypeInfo.proline = this.productionLine;
      }
    },
    // eslint-disable-next-line camelcase
    async getOutsourcer({ start_time, end_time }, formInfo) {
      const startTimeNum = start_time.getTime();
      const endTimeNum = end_time.getTime();
      if (this.outsourcer.length === 0 || startTimeNum !== this.formData.start_time
        || endTimeNum !== this.formatDate.end_time) {
        // eslint-disable-next-line no-underscore-dangle
        let _data = await getOutsourcer({
          start_time: startTimeNum,
          end_time: endTimeNum,
        });
        _data = _data.map(item => ({
          value: item.id,
          key: item.label,
        }));
        _data = [{ value: 0, key: '全部' }].concat(_data);
        this[formInfo].listTypeInfo.opr = _data;
        this.$store.commit('SET_OUTSOURCER', _data);
      } else {
        this[formInfo].listTypeInfo.opr = this.outsourcer;
      }
    },
    formChange(formInfo, { event, value }) {
      switch (event) {
        case 'startTimeChange':
          this.formData.start_time = value;
          this.getProLineAndOut({ ...this.formData }, formInfo);
          this.setOperator && this.setOperator({ ...this.formData });
          break;
        case 'endTimeChange':
          this.formData.end_time = value;
          this.getProLineAndOut({ ...this.formData }, formInfo);
          this.setOperator && this.setOperator({ ...this.formData });
          break;
      }
    },

  },
};
